import uploadEstimateFile from '../../../Services/uploadEstimateFile';

export default (acceptedFiles: FileList) => async (dispatch) => {

  dispatch(uploadEstimateFile(acceptedFiles))
  
}